import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Department } from 'src/app/Models/department.model';
import { NurseDailyPatient } from 'src/app/Models/nursedailypatient.model';
import { Patient } from 'src/app/Models/patient.model';
import { Ward } from 'src/app/Models/ward.model';
import { DepartmentService } from 'src/app/services/department.service';
import { HospitalService } from 'src/app/services/hospital.service';
import { NursedailypatientsService } from 'src/app/services/nursedailypatients.service';
import { PatientService } from 'src/app/services/patient.service';
import { UserService } from 'src/app/services/user.service';
import { WardService } from 'src/app/services/ward.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog-component';
import { NurseService } from 'src/app/services/nurse.service';

@Component({
  selector: 'app-view-nurse-patients-by-hospital',
  templateUrl: './view-nurse-patients-by-hospital.component.html',
  styleUrls: ['./view-nurse-patients-by-hospital.component.css'],
})
export class ViewNursePatientsByHospitalComponent implements OnInit {
  @Input() isNurse: boolean;
  @Output() selectedPatientIdsEmitter = new EventEmitter<any>();
  @Output() navigation = new EventEmitter<any>();
  selectedPatientIds: string[] = [];
  nursePatient: NurseDailyPatient[] = [];
  displayedColumns: string[] = [
    'FirstName',
    'LastName',
    'Gender',
    'PatientNationalId',
    'Email',
    'PhoneNumber',
    'PrimaryDoctor',
    'WardName',
    'View',
    'Edit',
    'Delete',
  ];
  id = 0;
  patientList: Patient[] = [];
  filteredList;
  dptList: Department;

  dataSource: MatTableDataSource<Patient>;

  helper = new JwtHelperService();
  myToken = window.localStorage.getItem('token');
  patientData;
  nurseId = 0;
  isSuccess = false;
  Frm: FormGroup;
  wardList: Ward[];
  hospitalId: number;
  constructor(
    private patientService: PatientService,
    private dptService: DepartmentService,
    private route: ActivatedRoute,
    private userService: UserService,
    private nursePatientService: NursedailypatientsService,
    private dialog: MatDialog,
    private router: Router,
    private wardService: WardService,
    private fb: FormBuilder,
    private hosptalService: HospitalService,
    private nurseService: NurseService
  ) {}

  ngOnInit(): void {
    let decodedToken = this.helper.decodeToken(this.myToken);
    this.nurseId = parseInt(decodedToken.nameid);

    // this.route.params.subscribe((res) => {
    //   this.id = res['id'];
    // });
    this.getWard();
    // this.getDptPatients(this.id)
    this.Frm = this.fb.group({
      WardId: [''],
    });
    this.nurseService.getNurseHospital(this.nurseId).subscribe((res) => {
      this.hospitalId = res.Hospital.HospitalId;
      // this.getWard(this.hospitalId);
      this.getPatients(this.hospitalId);
    });
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  get WardId() {
    return this.Frm.get('WardId');
  }
  getWard() {
    this.wardService.getWards().subscribe((res) => {
      this.wardList = res;
    });
  }

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }

  getPatients(id) {
    // this.wardService.getWardPatients(this.WardId.value).subscribe((res) => {
    //  this.filteredList= res
    this.hosptalService.getPatients(id).subscribe((res) => {
      this.dataSource = new MatTableDataSource(res.Patients);
      this.dataSource.paginator = this.paginator;
      // this.patientList=res;
    });
    if (this.isNurse) {
      this.displayedColumns.splice(0, 0, 'select', 'Id');
      this.displayedColumns = this.displayedColumns.filter((column, id) => {
        if (column === 'Edit' || column === 'Delete') {
          return;
        }
        return column;
      });
    }
  }

  deletePatient(id) {
    this.patientService.deletePatient(id).subscribe((res) => {
      this.userService.deleteUser(id).subscribe(
        (res) => {
          this.getPatients(this.id);
        },
        (error) => console.log(error)
      );
    });
  }

  selectPatients(event, patient) {
    this.patientData = {
      PatientId: patient.PatientId,
      PatientFirstName: patient.PatientFirstName,
      PatientLastName: patient.PatientLastName,
      PatientDOB: patient.PatientDOB,
      PatientNationalId: patient.PatientNationalId,
      PatientGender: patient.PatientGender,
      Email: patient.Email,
      PhoneNumber: patient.PhoneNumber,
      PrimaryDoctorsName: patient.PrimaryDoctorsName,
      WardName: patient.WardName,
      NurseId: this.nurseId,
    };
    let index = this.patientList?.findIndex(
      (patient) => patient?.PatientId === this.patientData?.PatientId
    );
    if (event.checked) {
      if (index > -1) {
        this.patientList[index] = this.patientData;
      } else {
        this.patientList.push(this.patientData);
      }
    } else if (index > -1) {
      this.patientList.splice(index, 1);
    }
  }

  emitSelectedIds() {
    this.selectedPatientIdsEmitter.emit(this.nursePatient);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  selectedPatient() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Assign Patient to me',
        content:
          'Are you sure you want to assign selected patient to your Work Space?',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res === true) {
          this.patientList.forEach((patient) => {
            console.log(res);
            this.nursePatientService
              .registerNurseDailyPatient(patient)
              .subscribe((res) => {
                this.isSuccess = true;
              });
          });
          setTimeout(() => {
            this.navigation.emit();
          }, 2000);
        }
      },
    });
  }
}
